import { createFileRoute } from "@tanstack/react-router";

import { InstalledConnectors } from "@/features/Connectors/InstalledConnectors";

export const Route = createFileRoute(
  "/_auth/settings/$siteId/connectors/installed",
)({
  component: InstalledConnectors,
});
